export const authRoles = {
    user: ['USER'], // users marked USER have access to pages with authRoles.user role
};